import React from 'react';
import { Icon } from 'antd';
import styled from 'styled-components';
import { Modal } from '../../components/Modal';
import { AISummaryData } from './aiSummaryApi';
import { FORUM_IAH_SALES_URL } from './constants';

interface IProps {
  visible: boolean;
  onClose: () => void;
  loading: boolean;
  notFound: boolean;
  error: string | null;
  data: AISummaryData | null;
}

const Body = styled.div`
  min-height: 180px;
  padding: 0.5rem 0.25rem;
  font-size: 0.95rem;
  line-height: 1.5;
  color: #1c1c1c;

  pre {
    background: #f6f7f9;
    padding: 1rem;
    border-radius: 6px;
    overflow: auto;
    font-size: 0.85rem;
  }
`;

const StatusRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 0;
  color: #595959;
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: 0.85rem;

  a {
    color: var(--primary-color, #d7282f);
    font-weight: 600;
  }
`;

const Title = (
  <span>
    <Icon type="thunderbolt" style={{ marginRight: 8 }} />
    Resumo com IA
  </span>
);

function renderSummary(data: AISummaryData | null) {
  if (!data) return null;

  if (typeof data === 'string') {
    return <p>{data}</p>;
  }

  const summaryText =
    (data as any).summary ||
    (data as any).markdown ||
    (data as any).content ||
    (data as any).text;

  if (typeof summaryText === 'string' && summaryText.trim().length > 0) {
    return <pre style={{ whiteSpace: 'pre-wrap' }}>{summaryText}</pre>;
  }

  return <pre>{JSON.stringify(data, null, 2)}</pre>;
}

export const AISummaryModal = ({
  visible,
  onClose,
  loading,
  notFound,
  error,
  data
}: IProps) => {
  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      onOk={onClose}
      okText="Fechar"
      cancelButtonProps={{ style: { display: 'none' } }}
      title={Title}
      width={720}
      destroyOnClose
      footer={
        <Footer>
          <a href={FORUM_IAH_SALES_URL} target="_blank" rel="noopener noreferrer">
            Saiba mais sobre o Forum IAH
          </a>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: 'var(--primary-color, #d7282f)',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              padding: '0.4rem 1rem',
              cursor: 'pointer'
            }}>
            Fechar
          </button>
        </Footer>
      }>
      <Body>
        {loading && (
          <StatusRow>
            <Icon type="loading" /> Gerando resumo com IA...
          </StatusRow>
        )}

        {!loading && error && (
          <StatusRow>
            <Icon type="exclamation-circle" /> {error}
          </StatusRow>
        )}

        {!loading && !error && notFound && (
          <StatusRow>
            <Icon type="info-circle" /> Resumo ainda não disponível para este conteúdo.
          </StatusRow>
        )}

        {!loading && !error && !notFound && renderSummary(data)}
      </Body>
    </Modal>
  );
};
